import { DeviceInfo } from '../../deviceInfo/deviceInfo';

const TIME_DIFF_ACCEPTABLE = 10000;

/**
 * RestartControllerClass manages listeners for restarting the application when the user comes back to the tab after a certain amount of time.
 */
export class RestartControllerClass {
  private tabLeftTime: number | null = null;

  private restartListeners = new Map<string, () => void>();

  constructor() {
    // Visibility change listener
    document.addEventListener('visibilitychange', () => {
      this.visibilityChangeHandler();
    });
  }

  // add listener callback to restart listener
  public addListener(type: string, listener: () => void): void {
    this.restartListeners.set(type, listener);
  }

  // remove listener from listeners Map
  public removeListener(type: string): void {
    this.restartListeners.delete(type);
  }

  // remove all listeners
  public removeAllListeners(): void {
    this.restartListeners.clear();
  }

  private visibilityChangeHandler(): void {
    if (!DeviceInfo.getPlatform().IS_ANDROID_OS) return;
    // when user comes from other tab
    if (document.visibilityState === 'visible') {
      if (this.tabLeftTime) {
        const timeDiff = Date.now() - this.tabLeftTime;
        // user spent more time than TIME_DIFF_ACCEPTABLE on other tab
        if (timeDiff > TIME_DIFF_ACCEPTABLE) {
          for (const callback of this.restartListeners.values()) {
            callback();
          }
        }
      }
      // user left tab, register time of leaving
    } else {
      this.tabLeftTime = Date.now();
    }
  }
}

export const RestartController = new RestartControllerClass();
